import type { MetadataItem } from '../tool-config-types';
import { formatCategorySmart } from '../../../../utils/category-utils';

type SignalInput = {
  signals?: Array<{ category?: string; label?: string }>;
  signal?: { category?: string; label?: string };
  category?: string;
  label?: string;
  title?: string;
};

const isSignalInput = (input: unknown): input is SignalInput => {
  return typeof input === 'object' && input !== null;
};

const LABEL_COLOR_MAP: Record<string, MetadataItem['color']> = {
  HOT: 'red',
  EXPLOITED: 'red',
  COLD: 'blue',
  PASSED: 'green',
};

/**
 * Extract metadata for signal tools
 * Shows: category, label, count
 */
export const extractSignalMetadata = ({
  input,
}: {
  input: unknown;
  output?: unknown;
}): MetadataItem[] => {
  const metadata: MetadataItem[] = [];

  if (!isSignalInput(input)) return metadata;

  let signals: Array<{ category?: string; label?: string }> = [];
  if (Array.isArray(input.signals)) {
    signals = input.signals;
  } else if (input.signal && typeof input.signal === 'object') {
    signals = [input.signal];
  } else if (input.category || input.label || input.title) {
    signals = [input];
  }

  if (signals.length > 1) {
    metadata.push({ label: 'Count', value: `${signals.length} signals` });
  }

  const category = signals[0]?.category;
  if (category) {
    metadata.push({
      label: 'Category',
      value: formatCategorySmart(category),
    });
  }

  const label = signals[0]?.label;
  if (label) {
    metadata.push({
      label: 'Label',
      value: formatCategorySmart(label),
      color: LABEL_COLOR_MAP[label.toUpperCase()],
    });
  }

  return metadata;
};
